import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-riLine-vip-line",
  "use": "icon-riLine-vip-line-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-riLine-vip-line\">\r\n    <path d=\"M2.667 25.333h26.667v2.667h-26.667v-2.667zM14.667 10.667h2.667v10.667h-2.667v-10.667zM10.62 10.667h2.833l-3.981 10.619h-2.667l-3.981-10.619h2.833l2.481 6.817 2.481-6.817zM22.667 18.667v2.667h-2.667v-10.667h5.333c2.209 0 4 1.791 4 4s-1.791 4-4 4v0h-2.667zM22.667 13.333v2.667h2.667c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333v0h-2.667zM2.667 4h26.667v2.667h-26.667v-2.667z\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/riLine-vip-line.svg
// module id = IcJE
// module chunks = 24